// //@ts-nocheck
// /* eslint-disable */
// import React, { useState, useEffect, useRef } from 'react';
// import { useNav } from '../../hooks/nav';

// import demo from '../../assets/images/demo.png';

// import { useStore } from 'src/onboarding/store/store';
// import { useMutation } from '@tanstack/react-query';

// import Analytics from '@web-solutions/module-analytics';
// import { useRemoteConfig } from '@web-solutions/base-app/hooks/use-remote-config';
// import { Title } from 'src/onboarding/components/typography/Title/Title';
// import { Text } from 'src/onboarding/components/typography/Text/Text';
// import { t } from '@web-solutions/module-localization';
// import { getEnvUrl } from 'src/onboarding/helpers/getEnvUrl';
// import Button from 'src/onboarding/components/ui/button/Button';

// import getLocale from 'src/localization/get-locale';
// import { BackIcon } from 'src/onboarding/assets/icons/BackIcon';
// import { Typography } from 'src/onboarding/components/typography-voery/Typography';
// import { ArrowBottomIcon } from 'src/onboarding/assets/icons/ArrowBottomIcon';
// import { ArrowsIcon } from 'src/onboarding/assets/icons/ArrowsIcon';
// import { MicrophoneFillIcon } from 'src/onboarding/assets/icons/MicrophoneFillIcon';
// import { ALL_LANGUAGES_KEYS, LANGUAGE_KEY_TO_LOCALE } from 'src/onboarding/constants/allLanguages';

// import axios from 'axios';
// import { Room, LocalAudioTrack, RoomEvent } from 'livekit-client';
// import { DataPacket_Kind } from 'livekit-client';

// function Page() {
//   const { onNext, onPrev, currentIndex } = useNav();
//   const locale = getLocale();

//   const { isShowedSkipButton } = useRemoteConfig();

//   const { nativeLanguage, setNativeLanguage, targetLanguage, setTargetLanguage } = useStore();
//   const [originalText, setOriginalText] = useState('');

//   const [isNativeOpen, setIsNativeOpen] = useState(false);
//   const [isTargetOpen, setIsTargetOpen] = useState(false);

//   // Состояния для Palabra AI
//   const [isRecording, setIsRecording] = useState(false);
//   const [isConnected, setIsConnected] = useState(false);
//   const [sessionData, setSessionData] = useState(null);
//   const [translatedText, setTranslatedText] = useState('');
//   const [error, setError] = useState('');

//   const nativeDropdownRef = useRef(null);
//   const targetDropdownRef = useRef(null);
//   const roomRef = useRef(null);
//   const mediaStreamRef = useRef(null);

//   const PALABRA_CLIENT_ID = 'f0a18a899cf6cf5498eb1aacbd09dca2';
//   const PALABRA_CLIENT_SECRET = 'adc137923fef511547b65c9c222fe66bfc42e6ec18b3067cec903e4fa9ff264d';

//   const translatedLanguages = ALL_LANGUAGES_KEYS.map((key) => ({
//     key,
//     name: t(`onboarding.common.languages.${key}`),
//   }));

//   const getLanguageName = (langKey) => {
//     if (!langKey) return t('onboarding.tryVoery.selectLanguage');
//     const language = translatedLanguages.find((lang) => lang.key === langKey);
//     return language ? language.name : langKey;
//   };

//   // Функция для создания сессии в Palabra AI
//   const createPalabraSession = async () => {
//     try {
//       setError('');
//       console.log('🔄 Создаём сессию Palabra AI...');

//       const { data } = await axios.post(
//         'https://api.palabra.ai/session-storage/session',
//         {
//           data: {
//             subscriber_count: 1,
//             publisher_can_subscribe: true,
//           },
//         },
//         {
//           headers: {
//             ClientId: PALABRA_CLIENT_ID,
//             ClientSecret: PALABRA_CLIENT_SECRET,
//             'Content-Type': 'application/json',
//           },
//         }
//       );

//       if (data.ok && data.data.publisher) {
//         console.log('✅ Сессия создана!', data.data);
//         setSessionData(data.data);
//         return data.data;
//       } else {
//         throw new Error('Не удалось создать сессию');
//       }
//     } catch (err) {
//       console.error('❌ Ошибка создания сессии:', err);
//       setError('Ошибка подключения к сервису перевода');
//       return null;
//     }
//   };

//   const startTranslation = async () => {
//     if (!nativeLanguage || !targetLanguage) {
//       setError('Пожалуйста, выберите языки');
//       return;
//     }

//     try {
//       setError('');
//       setIsRecording(true);

//       // 1️⃣ Создаем Palabra session
//       const session = await createPalabraSession();
//       if (!session) {
//         setIsRecording(false);
//         return;
//       }

//       // 2️⃣ Подключаемся к WebRTC
//       const room = new Room();
//       roomRef.current = room;

//       await room.connect(session.webrtc_url, session.publisher, {
//         autoSubscribe: true,
//       });

//       setIsConnected(true);
//       console.log('✅ Connected to WebRTC');

//       // 3️⃣ Публикуем МИКРОФОН правильно (как в документации)
//       const stream = await navigator.mediaDevices.getUserMedia({
//         audio: { channelCount: 1 },
//       });

//       mediaStreamRef.current = stream;

//       const localTrack = new LocalAudioTrack(stream.getAudioTracks()[0]);

//       await room.localParticipant.publishTrack(localTrack, {
//         dtx: false, // ОБЯЗАТЕЛЬНО для Palabra
//         red: false,
//         audioPreset: {
//           maxBitrate: 32000,
//           priority: 'high',
//         },
//       });

//       console.log('🎤 Audio track published');

//       // 4️⃣ Слушаем переведённый аудио трек
//       room.on(RoomEvent.TrackSubscribed, (track) => {
//         if (track.kind === 'audio') {
//           console.log('📥 Translation audio received');

//           const mediaStream = new MediaStream([track.mediaStreamTrack]);
//           const audio = new Audio();
//           audio.srcObject = mediaStream;
//           audio.play().catch(console.error);
//         }
//       });

//       // 5️⃣ Подписка на транскрипции
//       // 5️⃣ Подписка на транскрипции (и исходные, и переведенные)
//       room.on(RoomEvent.DataReceived, (payload) => {
//         try {
//           const message = JSON.parse(new TextDecoder().decode(payload));

//           // Проверяем тип сообщения
//           if (message.message_type === 'transcription') {
//             // 🎯 ИСХОДНАЯ ТРАНСКРИПЦИЯ (то, что сказал пользователь)
//             const data = typeof message.data === 'string' ? JSON.parse(message.data) : message.data;

//             // В зависимости от формата API, текст может быть в разных полях
//             // Обычно это data.text или data.transcription.text
//             const originalTextContent = data.text || data.transcription?.text || '';

//             if (originalTextContent) {
//               setOriginalText(originalTextContent);
//               console.log('🗣️ Original text:', originalTextContent);
//             }
//           } else if (message.message_type === 'translated_transcription') {
//             // 🌍 ПЕРЕВЕДЕННАЯ ТРАНСКРИПЦИЯ (уже есть в коде)
//             const data = typeof message.data === 'string' ? JSON.parse(message.data) : message.data;

//             // Обычно перевод приходит в data.translation или data.transcription.text
//             const translatedTextContent = data.translation?.text || data.transcription?.text || '';

//             if (translatedTextContent) {
//               setTranslatedText(translatedTextContent);
//               console.log('🌍 Translated text:', translatedTextContent);
//             }
//           }
//         } catch (e) {
//           console.error('Parse error:', e);
//         }
//       });

//       const sourceLang = LANGUAGE_KEY_TO_LOCALE[nativeLanguage.toLowerCase()];
//       const targetLang = LANGUAGE_KEY_TO_LOCALE[targetLanguage.toLowerCase()];
//       console.log(sourceLang, targetLang);
//       // 6️⃣ Отправляем set_task (ВАЖНО — после publishTrack)
//       const setTaskMessage = {
//         message_type: 'set_task',
//         data: {
//           input_stream: {
//             content_type: 'audio',
//             source: { type: 'webrtc' },
//           },
//           output_stream: {
//             content_type: 'audio',
//             target: { type: 'webrtc' },
//           },
//           pipeline: {
//             transcription: {
//               source_language: sourceLang,
//             },
//             translations: [
//               {
//                 target_language: targetLang,
//                 translate_partial_transcriptions: true,
//                 speech_generation: {
//                   voice_id: 'default_low',
//                 },
//               },
//             ],
//           },
//         },
//       };

//       const payload = new TextEncoder().encode(JSON.stringify(setTaskMessage));
//       await room.localParticipant.publishData(
//         payload,
//         DataPacket_Kind.RELIABLE,
//         'palabra:set_task'
//       );
//       console.log('📤 set_task sent');
//     } catch (err: any) {
//       console.error('❌ Error:', err);
//       setError(`Ошибка при запуске перевода: ${err.message}`);
//       setIsRecording(false);
//       stopTranslation();
//     }
//   };
//   // Функция остановки перевода
//   const stopTranslation = async () => {
//     try {
//       if (roomRef.current) {
//         await roomRef.current.disconnect();
//         roomRef.current = null;
//       }

//       setIsRecording(false);
//       setIsConnected(false);
//       setTranslatedText('');
//       setOriginalText(''); // 👈 Добавить сброс исходного текста
//       console.log('⏹️ Перевод остановлен');
//     } catch (err) {
//       console.error('Ошибка при остановке:', err);
//     }
//   };

//   // Функция для обмена языков
//   const swapLanguages = () => {
//     const temp = nativeLanguage;
//     setNativeLanguage(targetLanguage);
//     setTargetLanguage(temp);
//   };

//   const handleNativeLanguageSelect = (langKey) => {
//     setNativeLanguage(langKey);
//     setIsNativeOpen(false);
//   };

//   const handleTargetLanguageSelect = (langKey) => {
//     setTargetLanguage(langKey);
//     setIsTargetOpen(false);
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (nativeDropdownRef.current && !nativeDropdownRef.current.contains(event.target)) {
//         setIsNativeOpen(false);
//       }
//       if (targetDropdownRef.current && !targetDropdownRef.current.contains(event.target)) {
//         setIsTargetOpen(false);
//       }
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     document.addEventListener('touchstart', handleClickOutside);

//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//       document.removeEventListener('touchstart', handleClickOutside);
//       // Очищаем ресурсы при размонтировании
//       if (mediaStreamRef.current) {
//         mediaStreamRef.current.getTracks().forEach((track) => track.stop());
//       }
//       if (roomRef.current) {
//         roomRef.current.disconnect();
//       }
//     };
//   }, []);

//   return (
//     <div className={'page'}>
//       <div className={'controlsHeader'}>
//         {currentIndex !== 0 && (
//           <div className='back' onClick={onPrev}>
//             <BackIcon />
//           </div>
//         )}
//         {isShowedSkipButton && (
//           <div
//             className={'skip'}
//             onClick={() => {
//               Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
//                 page: 'try-voery',
//                 answer: 'skip',
//               });
//               onNext();
//             }}
//           >
//             {t('onboarding.tryVoery.skip')}
//           </div>
//         )}
//       </div>

//       <div className='wrapper-info'>
//         <Typography variant='h1-bold' className='title'>
//           {t('onboarding.tryVoery.title')}
//         </Typography>

//         <Typography variant='body-regular' className='description inline'>
//           {t('onboarding.tryVoery.subTitle')}{' '}
//           <Typography variant='body-bold'>{t('onboarding.tryVoery.threePhrases')}</Typography>{' '}
//           {t('onboarding.tryVoery.test')}
//         </Typography>
//         <img src={demo} alt='demo' className='demoIcon' />
//       </div>

//       <div className='controls'>
//         {/* Контейнер для дропдаунов */}
//         <div className='dropdowns-row'>
//           {/* Дропдаун родного языка */}
//           <div className='dropdown-container' ref={nativeDropdownRef}>
//             <div
//               className={`dropdown-header ${isNativeOpen ? 'active' : ''}`}
//               onClick={() => {
//                 setIsNativeOpen(!isNativeOpen);
//                 setIsTargetOpen(false);
//               }}
//             >
//               <div className='left-column'>
//                 <Typography variant='callout-medium' className='language-text'>
//                   {getLanguageName(nativeLanguage)}
//                 </Typography>
//                 <ArrowBottomIcon className={`dropdown-arrow ${isNativeOpen ? 'rotated' : ''}`} />
//               </div>
//             </div>

//             {/* Выпадающее меню для родного языка */}
//             {isNativeOpen && (
//               <div className='dropdown-menu'>
//                 <div className='dropdown-menu-list'>
//                   {translatedLanguages.map((lang) => (
//                     <label
//                       key={lang.key}
//                       className='dropdown-item'
//                       onClick={() => handleNativeLanguageSelect(lang.key)}
//                     >
//                       <input
//                         type='checkbox'
//                         checked={nativeLanguage === lang.key}
//                         onChange={() => {}}
//                         className='dropdown-checkbox'
//                       />
//                       <Typography variant='callout-medium' className='language-name'>
//                         {lang.name}
//                       </Typography>
//                     </label>
//                   ))}
//                 </div>
//               </div>
//             )}
//           </div>

//           {/* Иконка стрелок между дропдаунами - кликабельна для обмена языков */}
//           <div onClick={swapLanguages} style={{ cursor: 'pointer' }}>
//             <ArrowsIcon className='arrows-icon' />
//           </div>

//           {/* Дропдаун целевого языка */}
//           <div className='dropdown-container' ref={targetDropdownRef}>
//             <div
//               className={`dropdown-header ${isTargetOpen ? 'active' : ''}`}
//               onClick={() => {
//                 setIsTargetOpen(!isTargetOpen);
//                 setIsNativeOpen(false);
//               }}
//             >
//               <div className='right-column'>
//                 <Typography variant='callout-medium' className='language-text'>
//                   {getLanguageName(targetLanguage)}
//                 </Typography>
//                 <ArrowBottomIcon className={`dropdown-arrow ${isTargetOpen ? 'rotated' : ''}`} />
//               </div>
//             </div>

//             {/* Выпадающее меню для целевого языка */}
//             {isTargetOpen && (
//               <div className='dropdown-menu'>
//                 <div className='dropdown-menu-list'>
//                   {translatedLanguages.map((lang) => (
//                     <label
//                       key={lang.key}
//                       className='dropdown-item'
//                       onClick={() => handleTargetLanguageSelect(lang.key)}
//                     >
//                       <input
//                         type='checkbox'
//                         checked={targetLanguage === lang.key}
//                         onChange={() => {}}
//                         className='dropdown-checkbox'
//                       />
//                       <Typography variant='callout-medium' className='language-name'>
//                         {lang.name}
//                       </Typography>
//                     </label>
//                   ))}
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Индикатор подключения и ошибки */}
//         {error && (
//           <div className='error-message' style={{ color: 'red', margin: '10px 0' }}>
//             {error}
//           </div>
//         )}

//         {isConnected && (
//           <div className='connection-status' style={{ color: 'green', margin: '10px 0' }}>
//             ✅ Подключено к сервису перевода
//           </div>
//         )}

//         {/* Исходный текст (то, что сказал пользователь) */}
//         {originalText && (
//           <div
//             className='original-text'
//             style={{
//               margin: '10px 0',
//               padding: '10px',
//               background: '#e3f2fd',
//               borderRadius: '8px',
//               borderLeft: '4px solid #2196f3',
//             }}
//           >
//             <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
//               🗣️ Вы сказали:
//             </div>
//             <Typography variant='body-regular' style={{ fontWeight: 500 }}>
//               {originalText}
//             </Typography>
//           </div>
//         )}

//         {/* Переведенный текст */}
//         {translatedText && (
//           <div
//             className='translation-result'
//             style={{
//               margin: '10px 0',
//               padding: '10px',
//               background: '#f0f0f0',
//               borderRadius: '8px',
//               borderLeft: '4px solid #4caf50',
//             }}
//           >
//             <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>🌍 Перевод:</div>
//             <Typography variant='body-regular'>{translatedText}</Typography>
//           </div>
//         )}
//         <audio id='remote-audio' style={{ display: 'none' }} />

//         {/* Кнопка записи */}
//         <div
//           className={`speak-btn ${isRecording ? 'recording' : ''}`}
//           onClick={isRecording ? stopTranslation : startTranslation}
//           style={{
//             cursor: 'pointer',
//             opacity: (!nativeLanguage || !targetLanguage) && !isRecording ? 0.5 : 1,
//             backgroundColor: isRecording ? '#ff4444' : undefined,
//           }}
//         >
//           <MicrophoneFillIcon />
//           <Typography variant='callout-medium'>
//             {isRecording ? t('onboarding.tryVoery.stop') : t('onboarding.tryVoery.tap')}
//           </Typography>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Page;

//@ts-nocheck
// import { useEffect, useRef, useState } from 'react';
// import axios from 'axios';
// import { Room, LocalAudioTrack, RoomEvent, DataPacket_Kind } from 'livekit-client';

// const PALABRA_CLIENT_ID = 'f0a18a899cf6cf5498eb1aacbd09dca2';
// const PALABRA_CLIENT_SECRET = 'adc137923fef511547b65c9c222fe66bfc42e6ec18b3067cec903e4fa9ff264d';

// // Мы знаем обоих участников
// const CURRENT_USER_ID = 'userA';
// const OTHER_USER_ID = 'userB';

// export default function Page() {
//   const roomRef = useRef<Room | null>(null);
//   const mediaStreamRef = useRef<MediaStream | null>(null);

//   const [sessionA, setSessionA] = useState<any>(null);
//   const [sessionB, setSessionB] = useState<any>(null);

//   const [originalText, setOriginalText] = useState('');
//   const [translatedText, setTranslatedText] = useState('');

//   const [messages, setMessages] = useState<string[]>([]);
//   const [chatInput, setChatInput] = useState('');

//   const [isConnected, setIsConnected] = useState(false);

//   // -------------------------------
//   // 1️⃣ Создание Palabra Session
//   // -------------------------------
//   const createPalabraSession = async () => {
//     const { data } = await axios.post(
//       'https://api.palabra.ai/session-storage/session',
//       {
//         data: {
//           subscriber_count: 1,
//           publisher_can_subscribe: true,
//         },
//       },
//       {
//         headers: {
//           ClientId: PALABRA_CLIENT_ID,
//           ClientSecret: PALABRA_CLIENT_SECRET,
//           'Content-Type': 'application/json',
//         },
//       }
//     );

//     return data.data;
//   };

//   // -------------------------------
//   // 2️⃣ Создаём две Palabra-сессии
//   // -------------------------------
//   const setupSessions = async () => {
//     const a = await createPalabraSession();
//     const b = await createPalabraSession();

//     setSessionA(a);
//     setSessionB(b);
//   };

//   // -------------------------------
//   // 3️⃣ Подключение к LiveKit
//   // -------------------------------
//   const connectToLiveKit = async (mySession: any, otherSession: any) => {
//     const room = new Room();
//     roomRef.current = room;

//     await room.connect(mySession.webrtc_url, mySession.publisher, {
//       autoSubscribe: false,
//     });

//     setIsConnected(true);

//     // Публикуем микрофон
//     const stream = await navigator.mediaDevices.getUserMedia({
//       audio: { channelCount: 1 },
//     });

//     mediaStreamRef.current = stream;

//     const localTrack = new LocalAudioTrack(stream.getAudioTracks()[0]);

//     await room.localParticipant.publishTrack(localTrack, {
//       dtx: false,
//       red: false,
//       audioPreset: {
//         maxBitrate: 32000,
//         priority: 'high',
//       },
//     });

//     // -------------------------------
//     // 4️⃣ Слушаем перевод (только чужой)
//     // -------------------------------
//     room.on(RoomEvent.TrackSubscribed, (track, publication, participant) => {
//       if (participant.isLocal) return; // ❗ не проигрываем свои треки
//       if (track.kind === 'audio') {
//         const mediaStream = new MediaStream([track.mediaStreamTrack]);
//         const audio = new Audio();
//         audio.srcObject = mediaStream;
//         audio.play();
//       }
//     });

//     // -------------------------------
//     // 5️⃣ Транскрипции
//     // -------------------------------
//     room.on(RoomEvent.DataReceived, (payload) => {
//       try {
//         const message = JSON.parse(new TextDecoder().decode(payload));

//         if (message.message_type === 'transcription') {
//           const data = typeof message.data === 'string' ? JSON.parse(message.data) : message.data;

//           const text = data.text || data.transcription?.text || '';

//           if (text) setOriginalText(text);

//           setMessages((prev) => [
//             ...prev,
//             {
//               from: participant.identity, // кто говорил
//               original: text,
//               translated: null,
//             },
//           ]);
//         }

//         if (message.message_type === 'translated_transcription') {
//           const data = typeof message.data === 'string' ? JSON.parse(message.data) : message.data;

//           const text = data.translation?.text || data.transcription?.text || '';

//           if (text) setTranslatedText(text);

//           setMessages((prev) => {
//             const last = prev[prev.length - 1];
//             return [...prev.slice(0, -1), { ...last, translated: text }];
//           });
//         }
//       } catch (e) {
//         console.error('Parse error:', e);
//       }
//     });

//     // -------------------------------
//     // 6️⃣ Отправляем set_task
//     // -------------------------------
//     const setTaskMessage = {
//       message_type: 'set_task',
//       data: {
//         input_stream: {
//           content_type: 'audio',
//           source: { type: 'webrtc' },
//         },
//         output_stream: {
//           content_type: 'audio',
//           target: { type: 'webrtc' },
//         },
//         pipeline: {
//           transcription: {
//             source_language: 'en',
//           },
//           translations: [
//             {
//               target_language: 'es',
//               translate_partial_transcriptions: true,
//               speech_generation: {
//                 voice_id: 'default_low',
//               },
//             },
//           ],
//         },
//       },
//     };

//     const payload = new TextEncoder().encode(JSON.stringify(setTaskMessage));
//     await room.localParticipant.publishData(payload, DataPacket_Kind.RELIABLE, 'palabra:set_task');
//   };

//   // -------------------------------
//   // 7️⃣ Инициализация звонка
//   // -------------------------------
//   useEffect(() => {
//     (async () => {
//       await setupSessions();
//     })();
//   }, []);

//   useEffect(() => {
//     if (!sessionA || !sessionB) return;

//     const mySession = CURRENT_USER_ID === 'userA' ? sessionA : sessionB;
//     const otherSession = CURRENT_USER_ID === 'userA' ? sessionB : sessionA;

//     connectToLiveKit(mySession, otherSession);
//   }, [sessionA, sessionB]);

//   return (
//     <div style={{ padding: 20 }}>
//       <h1>Call Page</h1>

//       {isConnected ? (
//         <>
//           <h2>Вы в звонке</h2>

//           {/* <h3>Original</h3>
//           <div>{originalText}</div>

//           <h3>Translated</h3>
//           <div>{translatedText}</div> */}

//           <h3>Live Chat</h3>
//           <div>
//             {messages.map((m, i) => (
//               <div key={i} style={{ marginBottom: 10 }}>
//                 <strong>{m.from}:</strong> {m.original}
//                 {m.translated && (
//                   <div style={{ color: '#555', marginLeft: 10 }}>→ {m.translated}</div>
//                 )}
//               </div>
//             ))}
//           </div>
//         </>
//       ) : (
//         <div>Подключаемся...</div>
//       )}
//     </div>
//   );
// }

// import { useEffect, useRef, useState } from 'react';
// import axios from 'axios';
// import { Room, LocalAudioTrack, RoomEvent, DataPacket_Kind } from 'livekit-client';

// export default function CallTestPage() {
//   const roomRef = useRef(null);
//   const mediaStreamRef = useRef(null);

//   const [callUuid, setCallUuid] = useState('');
//   const [isConnected, setIsConnected] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [messages, setMessages] = useState([]);
//   const [error, setError] = useState('');

//   const API_BASE = 'https://stage-api.voery.app';

//   const cleanup = async () => {
//     try {
//       if (roomRef.current) {
//         await roomRef.current.disconnect();
//         roomRef.current = null;
//       }
//       if (mediaStreamRef.current) {
//         mediaStreamRef.current.getTracks().forEach((t) => t.stop());
//         mediaStreamRef.current = null;
//       }
//       setIsConnected(false);
//     } catch (e) {
//       console.error('Cleanup error', e);
//     }
//   };

//   const handleConnect = async () => {
//     if (!callUuid.trim()) {
//       setError('Введите callUuid');
//       return;
//     }

//     setError('');
//     setLoading(true);
//     setMessages([]);
//     await cleanup();

//     try {
//       // 1️⃣ Получаем сессии по UUID
//       const { data } = await axios.get(`${API_BASE}/palabra/session/call/${callUuid.trim()}`);

//       if (!data.success || !data.sessions?.length) {
//         setError('Сессии не найдены');
//         setLoading(false);
//         return;
//       }

//       const sessions = data.sessions;

//       // Определяем роли
//       const mySession = sessions.find((s) => !s.isCreator) || sessions[0];
//       const otherSession = sessions.find((s) => s.isCreator) || sessions[1] || sessions[0];

//       console.log('mySession', mySession);
//       console.log('otherSession', otherSession);

//       // 2️⃣ Подключаемся к LiveKit
//       const room = new Room();
//       roomRef.current = room;

//       await room.connect(mySession.webrtcUrl, mySession.publisher, {
//         autoSubscribe: false,
//       });

//       setIsConnected(true);

//       // 3️⃣ Публикуем микрофон
//       const stream = await navigator.mediaDevices.getUserMedia({
//         audio: { channelCount: 1 },
//       });
//       mediaStreamRef.current = stream;

//       const localTrack = new LocalAudioTrack(stream.getAudioTracks()[0]);

//       await room.localParticipant.publishTrack(localTrack, {
//         dtx: false,
//         red: false,
//       });

//       // 4️⃣ Подписываемся только на чужие аудио-треки (перевод)
//       room.on(RoomEvent.TrackPublished, async (publication, participant) => {
//         if (participant.isLocal) return;
//         if (publication.kind === 'audio') {
//           try {
//             await publication.subscribe();
//           } catch (e) {
//             console.error('Error subscribing to audio track', e);
//           }
//         }
//       });

//       room.on(RoomEvent.TrackSubscribed, (track, publication, participant) => {
//         if (participant.isLocal) return;

//         if (track.kind === 'audio') {
//           const mediaStream = new MediaStream([track.mediaStreamTrack]);
//           const audio = new Audio();
//           audio.srcObject = mediaStream;
//           audio.play().catch(console.error);
//         }
//       });

//       // 5️⃣ Лайв-чат: оригинал + перевод
//       room.on(RoomEvent.DataReceived, (payload, participant) => {
//         try {
//           const decoded = new TextDecoder().decode(payload);
//           const msg = JSON.parse(decoded);

//           const from = participant?.identity || (participant.isLocal ? 'You' : 'Remote');

//           // ОРИГИНАЛ
//           if (msg.message_type === 'transcription') {
//             const rawData = typeof msg.data === 'string' ? JSON.parse(msg.data) : msg.data;

//             const text = rawData?.text || rawData?.transcription?.text || '';

//             if (!text) return;

//             setMessages((prev) => [
//               ...prev,
//               {
//                 from,
//                 original: text,
//                 translated: null,
//               },
//             ]);
//           }

//           // ПЕРЕВОД
//           if (msg.message_type === 'translated_transcription') {
//             const rawData = typeof msg.data === 'string' ? JSON.parse(msg.data) : msg.data;

//             const text = rawData?.translation?.text || rawData?.transcription?.text || '';

//             if (!text) return;

//             setMessages((prev) => {
//               if (!prev.length) {
//                 return [
//                   {
//                     from,
//                     original: '',
//                     translated: text,
//                   },
//                 ];
//               }
//               const last = prev[prev.length - 1];
//               return [
//                 ...prev.slice(0, -1),
//                 {
//                   ...last,
//                   translated: text,
//                 },
//               ];
//             });
//           }
//         } catch (e) {
//           console.error('DataReceived parse error', e);
//         }
//       });

//       // 6️⃣ Отправляем set_task
//       const setTaskMessage = {
//         message_type: 'set_task',
//         data: {
//           input_stream: {
//             content_type: 'audio',
//             source: { type: 'webrtc' },
//           },
//           output_stream: {
//             content_type: 'audio',
//             target: { type: 'webrtc' },
//           },
//           pipeline: {
//             transcription: {
//               source_language: mySession.sourceLanguage.code,
//             },
//             translations: [
//               {
//                 target_language: mySession.targetLanguage.code,
//                 translate_partial_transcriptions: true,
//                 speech_generation: {
//                   voice_id: 'default_low',
//                 },
//               },
//             ],
//           },
//         },
//       };

//       const payload = new TextEncoder().encode(JSON.stringify(setTaskMessage));
//       await room.localParticipant.publishData(
//         payload,
//         DataPacket_Kind.RELIABLE,
//         'palabra:set_task'
//       );
//     } catch (e) {
//       console.error(e);
//       setError('Ошибка подключения');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     return () => {
//       cleanup();
//     };
//   }, []);

//   return (
//     <div style={{ padding: 20 }}>
//       <h1>Test Call Page (Invited User)</h1>

//       {!isConnected && (
//         <div style={{ marginBottom: 20 }}>
//           <input
//             value={callUuid}
//             onChange={(e) => setCallUuid(e.target.value)}
//             placeholder='Введите callUuid'
//             style={{ padding: 8, width: 300 }}
//           />
//           <button onClick={handleConnect} disabled={loading} style={{ marginLeft: 10 }}>
//             {loading ? 'Подключаемся...' : 'Connect'}
//           </button>
//         </div>
//       )}

//       {error && <div style={{ color: 'red' }}>{error}</div>}

//       {isConnected && (
//         <>
//           <h2>Live Chat (Speech Log)</h2>

//           <div
//             style={{
//               border: '1px solid #ccc',
//               padding: 10,
//               height: 250,
//               overflowY: 'auto',
//               marginBottom: 10,
//             }}
//           >
//             {messages.map((m, i) => (
//               <div key={i} style={{ marginBottom: 10 }}>
//                 <strong>{m.from}:</strong> {m.original}
//                 {m.translated && (
//                   <div style={{ color: '#555', marginLeft: 10 }}>→ {m.translated}</div>
//                 )}
//               </div>
//             ))}
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Room, LocalAudioTrack, RoomEvent, DataPacket_Kind } from 'livekit-client';

export default function CallTwoRoomsTestPage() {
  const roomMyRef = useRef(null);
  const roomOtherRef = useRef(null);
  const mediaStreamRef = useRef(null);

  const [callUuid, setCallUuid] = useState('');
  const [isConnected, setIsConnected] = useState(false);
  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState([]);
  const [error, setError] = useState('');

  const API_BASE = 'https://stage-api.voery.app';

  const cleanup = async () => {
    try {
      if (roomMyRef.current) {
        await roomMyRef.current.disconnect();
        roomMyRef.current = null;
      }
      if (roomOtherRef.current) {
        await roomOtherRef.current.disconnect();
        roomOtherRef.current = null;
      }
      if (mediaStreamRef.current) {
        mediaStreamRef.current.getTracks().forEach((t) => t.stop());
        mediaStreamRef.current = null;
      }
      setIsConnected(false);
    } catch (e) {
      console.error('Cleanup error', e);
    }
  };

  const handleConnect = async () => {
    if (!callUuid.trim()) {
      setError('Введите callUuid');
      return;
    }

    setError('');
    setLoading(true);
    setMessages([]);
    await cleanup();

    try {
      // 1️⃣ Получаем сессии
      const { data } = await axios.get(`${API_BASE}/palabra/session/call/${callUuid.trim()}`);

      if (!data.success || !data.sessions?.length) {
        setError('Сессии не найдены');
        setLoading(false);
        return;
      }

      const sessions = data.sessions;

      // mySession — тот, за кого сейчас заходим
      const mySession = sessions.find((s) => !s.isCreator);
      // otherSession — вторая сторона
      const otherSession = sessions.find((s) => s.isCreator);

      console.log('mySession', mySession);
      console.log('otherSession', otherSession);

      console.log('roomNames:', mySession.webrtcRoomName, otherSession.webrtcRoomName);

      // 2️⃣ Создаём две комнаты
      const roomMy = new Room();
      const roomOther = new Room();

      roomMyRef.current = roomMy;
      roomOtherRef.current = roomOther;

      await roomMy.connect(mySession.webrtcUrl, mySession.publisher, {
        autoSubscribe: false,
      });

      roomMy.on(RoomEvent.Disconnected, (reason) => {
        console.log('ROOM DISCONNECTED:', reason);
      });

      roomOther.on(RoomEvent.TrackPublished, async (publication, participant) => {
        if (publication.kind === 'audio' && participant.identity.includes('palabra')) {
          console.log('Subscribing to Palabra audio:', participant.identity);
          await publication.subscribe();
        }
      });

      roomOther.on(RoomEvent.TrackSubscribed, (track, publication, participant) => {
        if (track.kind === 'audio' && participant.identity.includes('palabra')) {
          console.log('PLAYING TRANSLATED AUDIO from', participant.identity);
          const mediaStream = new MediaStream([track.mediaStreamTrack]);
          const audio = new Audio();
          audio.srcObject = mediaStream;
          audio.play().catch(console.error);
        } else {
          console.log('Skipping ORIGINAL audio from', participant.identity);
        }
      });

      await roomOther.connect(otherSession.webrtcUrl, otherSession.subscriber, {
        autoSubscribe: true,
      });

      setIsConnected(true);

      // 5️⃣ Публикуем микрофон в roomMy
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: { channelCount: 1 },
      });
      mediaStreamRef.current = stream;

      const localTrack = new LocalAudioTrack(stream.getAudioTracks()[0]);

      console.log('PUBLISH START, state =', roomMy.state);

      await roomMy.localParticipant.publishTrack(localTrack, {
        dtx: false,
        red: false,
      });
      console.log('PUBLISH OK');


      // Общий обработчик DataReceived (из обеих комнат)
      const handleData = (payload, participant) => {
        try {
          const decoded = new TextDecoder().decode(payload);
          const msg = JSON.parse(decoded);

          const from = participant?.identity || (participant?.isLocal ? 'You' : 'Remote');

          if (msg.message_type === 'transcription') {
            const raw = typeof msg.data === 'string' ? JSON.parse(msg.data) : msg.data;
            const text = raw?.text || raw?.transcription?.text || '';
            if (!text) return;

            setMessages((prev) => [...prev, { from, original: text, translated: null }]);
          }

          if (msg.message_type === 'translated_transcription') {
            const raw = typeof msg.data === 'string' ? JSON.parse(msg.data) : msg.data;
            const text = raw?.translation?.text || raw?.transcription?.text || '';
            if (!text) return;

            setMessages((prev) => {
              if (!prev.length) {
                return [{ from, original: '', translated: text }];
              }
              const last = prev[prev.length - 1];
              return [...prev.slice(0, -1), { ...last, translated: text }];
            });
          }
        } catch (e) {
          console.error('Data parse error', e);
        }
      };

      roomMy.on(RoomEvent.DataReceived, handleData);
      roomOther.on(RoomEvent.DataReceived, handleData);

      // 8️⃣ Отправляем set_task в свою комнату (roomMy)
      const setTaskMessage = {
        message_type: 'set_task',
        data: {
          input_stream: {
            content_type: 'audio',
            source: { type: 'webrtc' },
          },
          output_stream: {
            content_type: 'audio',
            target: { type: 'webrtc' },
          },
          pipeline: {
            transcription: {
              source_language: mySession.sourceLanguage.code,
            },
            translations: [
              {
                target_language: mySession.targetLanguage.code,
                translate_partial_transcriptions: true,
                speech_generation: {
                  voice_id: 'default_low',
                },
              },
            ],
          },
        },
      };

      const payload = new TextEncoder().encode(JSON.stringify(setTaskMessage));
      console.log('PUBLISH DATA START');
      await roomMy.localParticipant.publishData(
        payload,
        DataPacket_Kind.RELIABLE,
        'palabra:set_task'
      );
      console.log('PUBLISH DATA OK');
    } catch (e) {
      console.error(e);
      setError('Ошибка подключения');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    return () => {
      cleanup();
    };
  }, []);

  return (
    <div style={{ padding: 20 }}>
      <h1>Test Call Page (Two Rooms)</h1>

      {!isConnected && (
        <div style={{ marginBottom: 20 }}>
          <input
            value={callUuid}
            onChange={(e) => setCallUuid(e.target.value)}
            placeholder='Введите callUuid'
            style={{ padding: 8, width: 300 }}
          />
          <button onClick={handleConnect} disabled={loading} style={{ marginLeft: 10 }}>
            {loading ? 'Подключаемся...' : 'Connect'}
          </button>
        </div>
      )}

      {error && <div style={{ color: 'red' }}>{error}</div>}

      {isConnected && (
        <>
          <h2>Live Chat (Speech Log)</h2>

          <div
            style={{
              border: '1px solid #ccc',
              padding: 10,
              height: 250,
              overflowY: 'auto',
              marginBottom: 10,
            }}
          >
            {messages.map((m, i) => (
              <div key={i} style={{ marginBottom: 10 }}>
                <strong>{m.from}:</strong> {m.original}
                {m.translated && (
                  <div style={{ color: '#555', marginLeft: 10 }}>→ {m.translated}</div>
                )}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
